/**
 * Sectors Color Map
 * keys : sectorIds (1,2,3 ...)
 */
export const SectorsColorMap = {
  1: { sector: "FMCG", color: "#FF0000", colorName: "red" },
  2: { sector: "Finance", color: "#000080", colorName: "navy-blue" },
  3: {
    sector: "Entertainment & Leisure",
    color: "#FFA500",
    colorName: "orange",
  },
  4: { sector: "Automobile", color: "#4682B4", colorName: "steel-blue" },
  5: { sector: "Fuel & Energy", color: "#FF8C00", colorName: "dark-orange" },
  6: { sector: "Beauty & Self Care", color: "#FFC0CB", colorName: "pink" },
  7: { sector: "Kids & Baby Care", color: "#ADD8E6", colorName: "light-blue" },
  8: { sector: "Sport Equipment", color: "#32CD32", colorName: "lime-green" },
  9: { sector: "Accessories", color: "#DDA0DD", colorName: "plum" },
  10: { sector: "Clothes & Apparel", color: "#800080", colorName: "purple" },
  11: { sector: "Footwear", color: "#800000", colorName: "maroon" },
  12: { sector: "Electronics", color: "#0000FF", colorName: "blue" },
  13: {
    sector: "Home and Kitchen",
    color: "#808000",
    colorName: "olive-green",
  },
  14: { sector: "Travel & Tourism", color: "#008080", colorName: "teal" },
  15: { sector: "Hospitality", color: "#DAA520", colorName: "goldenrod" },
  16: { sector: "Sustenance", color: "#006400", colorName: "dark-green" },
  17: { sector: "Food", color: "#FF6347", colorName: "tomato" },
  18: { sector: "Drinks", color: "#87CEEB", colorName: "sky-blue" },
  19: { sector: "Education", color: "#9370DB", colorName: "medium-purple" },
  20: { sector: "School", color: "#90EE90", colorName: "light-green" },
  21: { sector: "Colleges", color: "#F08080", colorName: "light-coral" },
  22: {
    sector: "Coaching Institute",
    color: "#C71585",
    colorName: "medium-violet-red",
  },
  23: { sector: "University", color: "#4B0082", colorName: "indigo" },
  24: { sector: "Library", color: "#A52A2A", colorName: "brown" },
  25: { sector: "Road Transit", color: "#708090", colorName: "slate-gray" },
  26: {
    sector: "Rail Transit",
    color: "#483D8B",
    colorName: "dark-slate-blue",
  },
  27: { sector: "Air Transit", color: "#1E90FF", colorName: "dodger-blue" },
  28: { sector: "Water Transit", color: "#00BFFF", colorName: "deep-sky-blue" },
  29: { sector: "Healthcare", color: "#228B22", colorName: "forest-green" },
  30: { sector: "Hospitals", color: "#DC143C", colorName: "crimson" },
  31: { sector: "Clinics", color: "#3CB371", colorName: "medium-sea-green" },
  34: { sector: "Sport", color: "#7FFF00", colorName: "chartreuse" },
  35: { sector: "Indoor Sports", color: "#FF69B4", colorName: "hot-pink" },
  36: { sector: "Outdoor Sports", color: "#BDB76B", colorName: "dark-khaki" },
  38: { sector: "Fitness", color: "#00FA9A", colorName: "medium-spring-green" },
  39: { sector: "Workplace", color: "#778899", colorName: "light-slate-gray" },
  40: { sector: "Private Workplace", color: "#008B8B", colorName: "dark-cyan" },
  41: { sector: "Govt Office", color: "#8B0000", colorName: "dark-red" },
  42: { sector: "Manufacturing", color: "#8B4513", colorName: "saddle-brown" },
  43: { sector: "Crafts", color: "#FF4500", colorName: "orange-red" },
  44: { sector: "Places of Worship", color: "#DA70D6", colorName: "orchid" },
  45: { sector: "Residential", color: "#BC8F8F", colorName: "rosy-brown" },
  46: { sector: "Others", color: "#D3D3D3", colorName: "light-gray" },
  47: {
    sector: "Social Services",
    color: "#B8860B",
    colorName: "dark-goldenrod",
  },
  48: {
    sector: "Marketing, Media & Communications",
    color: "#BA55D3",
    colorName: "medium-orchid",
  },
  50: {
    sector: "Real Estate & Infrastructure",
    color: "#6A5ACD",
    colorName: "slate-blue",
  },
  51: {
    sector: "Community & Social Organizations",
    color: "#6495ED",
    colorName: "cornflower-blue",
  },
  52: { sector: "Energy & Utilities", color: "#CD853F", colorName: "peru" },
  53: {
    sector: "Parks & Recreation",
    color: "#66CDAA",
    colorName: "medium-aquamarine",
  },
  54: { sector: "NBFC", color: "#4169E1", colorName: "royal-blue" },
  56: { sector: "Safety Services", color: "#DC143C", colorName: "crimson" },
  57: {
    sector: "Maritime & Navigation",
    color: "#20B2AA",
    colorName: "light-sea-green",
  },
  58: {
    sector: "Water & Sewage Management",
    color: "#40E0D0",
    colorName: "turquoise",
  },
  59: {
    sector: "Telecommunications & Broadcasting",
    color: "#0000CD",
    colorName: "medium-blue",
  },
  60: {
    sector: "Defense & National Security",
    color: "#2F4F4F",
    colorName: "dark-slate-gray",
  },
  61: {
    sector: "Public & Utilities",
    color: "#708090",
    colorName: "slate-gray",
  },
  62: {
    sector: "Agriculture & Farming",
    color: "#556B2F",
    colorName: "dark-olive-green",
  },
  63: { sector: "Retail Stores", color: "#FF7F50", colorName: "coral" },
  65: {
    sector: "Water & Sewage, Waste Management",
    color: "#4682B4",
    colorName: "steel-blue",
  },
  66: {
    sector: "Administrative Unit",
    color: "#6B8E23",
    colorName: "olive-drab",
  },
  67: { sector: "Heritage Site", color: "#A0522D", colorName: "sienna" },
};
